import { isTokenExpired, getNewAuthToken } from "../utils";
import axios from "../utils/axios";
import setAuthToken from "../utils/setAuthToken";
import { baseURL } from "../utils/url";
import { CLEAR_DASHBOARD, DASHBOARD } from "./type";

export const getDashboard = (token, code, year) => async (dispatch) => {
    const valid = await isTokenExpired(token);
    try {
        if (!valid)
        setAuthToken(token);
		const headers = { 'Content-Type': 'application/json' };
            await getNewAuthToken().then((res) => {
                localStorage.setItem("token_gen", JSON.stringify(res));
                token = res?.access_token;
            });
        const fetchResponse = await axios.get(`dashboard?id=${code}&year=${year}`, {
            headers:headers
        });
        fetchResponse
            .json()
            .then((res) => {
                dispatch({
                    type: DASHBOARD,
                    payload: res,
                });
                return res;
            })
            .catch(() => {
                return null;
            });
    } catch (error) {
        return error;
    }
};

export const clearDashboard = () => async (dispatch) => {
    dispatch({ type: CLEAR_DASHBOARD });
};

export const getUserJourneyReport = async (token, id) => {
    const valid = await isTokenExpired(token);
    try {
        if (!valid)
            await getNewAuthToken().then((res) => {
                localStorage.setItem("token_gen", JSON.stringify(res));
                token = res?.access_token;
            });
            setAuthToken(token);
		const headers = { 'Content-Type': 'application/json' };
        const fetchResponse = await axios.get(`userJourneyReport?id=${id}`, {
            headers: headers,
        });
        return fetchResponse?.data;
    } catch (error) {
        return error;
    }
};
export const getDasboardReport = async (token, id) => {
    const valid = await isTokenExpired(token);
    try {
        if (!valid)
            await getNewAuthToken().then((res) => {
                localStorage.setItem("token_gen", JSON.stringify(res));
                token = res?.access_token;
            });
            setAuthToken(token);
		const headers = { 'Content-Type': 'application/json' };
        const fetchResponse = await axios.get(`dashboardData?id=${id}`, {
            headers: headers,
        });
        return fetchResponse?.data;
    } catch (error) {
        return error;
    }
};

